module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Blyd and Pearce")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Kim Fielding")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Born into poverty and orphaned young, Daveth Blyd had one chance for success when his fighting prowess earned him a place in the Tangye city guard—a place he lost to false accusations of theft. Now he scrapes out a living searching for wayward spouses and missing children. When a nobleman offers him a small fortune to find an entertainer who’s stolen a ring, Daveth takes the case.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("While Jory Pearce may or may not be a thief, he certainly can’t be trusted. But, enchanted by Jory’s beauty and haunting voice, Daveth soon finds himself caught in the middle of a conspiracy. As he searches desperately for answers, he realizes that he’s also falling for Jory. On their search for the truth, the two men face river wraiths, assassins, a necromancer, and a talking head that could be Daveth’s salvation. But with everyone’s integrity in question and Death eager to dance, Daveth will need more than sorcery to survive.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0